// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/fx-calculator/fx-calculator.component.scss
// module id = 740
// module chunks = 0